__webpack_require__.p = "/reports-details-deleted-candidate-style/onboarding/";